import { useState, useEffect, useCallback } from 'react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  const checkIsMobile = useCallback(() => {
    const newIsMobile = window.innerWidth < 768; // Adjust the threshold as needed

    if (newIsMobile !== isMobile) {
      setIsMobile(newIsMobile);
    }
  }, [isMobile]);

  useEffect(() => {
    // Initial check
    checkIsMobile();

    // Debounce the event listener
    const debouncedCheckIsMobile = debounce(checkIsMobile, 200); // Adjust the debounce time

    // Event listener for window resize
    window.addEventListener('resize', debouncedCheckIsMobile);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', debouncedCheckIsMobile);
    };
  }, [checkIsMobile]);

  return isMobile;
};

// Debounce function
function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}

export default useIsMobile;
